import config from 'components/GetStarted/config'
import { DEFAULT_STEP } from 'components/GetStarted/constants'
import { STATUS_CODES } from 'utils/Constants'
import { getStepIndexFromUrlSlug } from 'utils/getStartedUtils'
import { MiddlewareFunction } from './index'

export const handleInvalidGetStartedStepRedirect: MiddlewareFunction = async (data, next) => {
  const { nextContext } = data
  const { req, res } = nextContext
  const isGetStartedRoute = req?.url?.includes('/get-started')
  if (!isGetStartedRoute) {
    return next()
  }

  const currentPageIndex = getStepIndexFromUrlSlug(config.steps, nextContext?.query?.step)
  const isValidPage = currentPageIndex !== null && currentPageIndex !== -1
  const originalUrl = req?.url ?? ''
  const queryStartIndex = originalUrl.indexOf('?')
  const originalQuery = queryStartIndex >= 0 ? originalUrl.substring(queryStartIndex) : ''

  // if invalid page server side redirect to default step
  if (!isValidPage) {
    res.writeHead(STATUS_CODES.CODE302, {
      Location: `/get-started/${DEFAULT_STEP}${originalQuery}`,
    })
    res.end()

    return {
      isServerSideRedirect: true,
      errorCode: null,
    }
  } else {
    return next()
  }
}
